import React from 'react';
import Heading from '@tds/core-heading';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { stylePage } from './styles';

const ThankYou = () => {
  const {
    THANK_YOU_PAGE: {
      THANK_YOU,
      MESSAGE
    }
  } = useLocalizedStringsContext();
  return (
    <div style={stylePage}>
      <div id="main">
        <div id="main-wrapper">
          <div id="main-content" style={{ textAlign: 'center' }}>
            <Heading level="h2">
              {THANK_YOU}
            </Heading>
            <br />
            <p>
              {MESSAGE}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThankYou;
